<template lang="pug">
  el-container(id="app")
    .button-wrapper(v-if="showButton()")
      el-button#show-bp(type="primary", @click='showChatbot()')
        i.fal.fa-comments-alt.icon-size
    el-header.header-menu
      app-header
    el-main
      router-view.home-content
      app-footer
</template>

<script>
import AppHeader from '@/screens/portal/publico/components/Header'
import AppFooter from '@/screens/portal/publico/components/Footer'
const { showChatbotButton } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppHeader,
    AppFooter
  },

  computed: {
    enableChatbot () {
      return showChatbotButton
    }
  },

  methods: {
    showChatbot () {
      window.botpressWebChat.sendEvent({ type: 'show' })
    },
    showButton () {
      return process.env.ESTADO === 'pa'
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .header-menu {
    z-index: 1001;
  }
}

.el-main {
  padding: 0 !important;
  overflow: inherit;
}

.el-header {
  padding: 0 !important;
  position: relative;
  height: 120px !important;
}

.home-content {
  padding: 0 5% 0 5% !important;
  min-height: 83.1%;
}

@media screen and (min-width: 1220px) {
  .home-content {
    padding: 0 7% 0 7% !important;
  }
}

@media screen and (min-width: 1440px) {
  .home-content {
    padding: 0 5% 0 5% !important;
  }
}
</style>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.default-iframe {
  border-radius: 10px;
  border: $color-primary 2px solid;
  box-shadow: 2px 2px 5px $color-primary;
}

@media only screen and (max-width: 1256px) {
  .default-iframe {
    width: 100%;
  }
}

#show-bp {
    border-radius: 100px;
    width: 30px;
    height: 30px;
    padding: 30px;
    position: relative;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.2);
    z-index: 2;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.button-wrapper {
    right: 5vw;
    bottom: 4vh;
    z-index: 5;
    position: fixed;
}

.icon-size {
  font-size: 30px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/MainPage.vue